import React from "react";

interface LiveblogGameSummaryPhaseSeparatorProps {
  label: string
}

export function LiveblogGameSummaryPhaseSeparator({label}: LiveblogGameSummaryPhaseSeparatorProps) {
  return <div className="tik4-gsg__sep">
    <div className="tik4-gsg__sep-b"></div>
    <div className="tik4-gsg__sep-l">
      {label}
    </div>
    <div className="tik4-gsg__sep-b"></div>
  </div>
}
